import { lazy } from "react";

const CompletedAgreementPage = lazy(() => import("./CompletedAgreementPage"));

export { CompletedAgreementPage };
